import React from 'react'

import BaseComponent from 'utils/BaseComponent'

import { connect } from 'react-redux'

import './style.scss'


const images = {
  progress: require('./img/radial-progress.png'),
  error: require('./img/close-icon-error.svg'),
  ok: require('./img/close-icon-ok.svg')
}

export class RequestStatus extends BaseComponent {
  constructor(props) {
    super(props)

    this.state = {
      visible: false,
      disappear: false
    }

    // allow us to call clearTimeout so if another props.status change
    // occurs before previous timeout has been executed
    // new timeout count will start from 0 and component will not disappear unexpectedly
    this.timeout = null
    this._bind('_close')
  }

  componentWillReceiveProps(nextProps) {
    let visible = nextProps.status === 'progress',
      disappear = !visible
    this.timeout && clearTimeout(this.timeout)

    if ( visible ) {
      this.setState({ visible, disappear })
    } else {
      // schedule component close
      this.timeout = setTimeout(this._close, 100000)
      // start css.disappear animation
      this.setState({ disappear })
    }
  }

  _close() {
    this.timeout && clearTimeout(this.timeout)
    this.setState({
      visible: false,
      disappear: false
    })
  }

  render() {
    const visibleClass = this.state.disappear ? 'hidden' : 'visible'
    const statusClass = this.props.status
    return this.state.visible && !!this.props.status && this.props.message ? (
      <div className={`RequestStatus animation-${visibleClass} status-${statusClass}`}>
        <p>{this.props.message}</p>
        <div>
          <img
            src={images[this.props.status]}
            alt="request status"
            onClick={this._close}
          />
        </div>
      </div>
    ) : null
  }
}


const mapStateToProps = (state) => {
  return {
    status: state.requestStatus.get('status'),
    message: state.requestStatus.get('message')
  }
}

export default connect(mapStateToProps)(RequestStatus)



// WEBPACK FOOTER //
// ./src/components/RequestStatus/index.js